// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__xofsz","left":"header_left__ZLnuo","logo":"header_logo__9b1Md"};